<template>
  <svg
    width="24px"
    height="25px"
    viewBox="0 0 24 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :fill="color"
  >
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="侧边栏组件" transform="translate(-1813.000000, -1310.000000)">
        <g id="编组-4备份-6" transform="translate(1630.000000, 1305.500000)">
          <g id="在线客服备份" transform="translate(163.000000, 0.000000)">
            <g id="编组-15" transform="translate(20.000000, 5.000000)">
              <rect id="矩形" fill="#FFFFFF" opacity="0" x="0" y="0" width="24" height="24"></rect>
              <path
                d="M12.0013149,2.85721584 C7.59034802,2.85721584 4.00257732,6.50978437 4.00257732,11.0316906 C4.00257732,11.0686837 4.00537377,11.1048778 4.00972825,11.1412317 C4.00257732,11.1995977 4.00257732,11.2593619 4.00257732,11.3191661 L4.00257732,13.6156142 C3.94141487,14.8180095 4.90890809,15.8417115 6.17026868,15.9086266 L6.71242123,15.9086266 C7.97597903,15.8424705 8.94507022,14.8165713 8.8823098,13.6128177 L8.8823098,11.3183671 C8.94427124,10.1159717 7.97673807,9.09151073 6.71537748,9.02391644 L6.17246589,9.02391644 C6.09524381,9.02391644 6.01798178,9.02815107 5.94119914,9.03674018 C6.51391294,6.94938695 8.22502324,5.31877457 10.4163247,4.7723075 C13.7642395,3.93788555 17.1877385,5.84670516 18.0642671,9.03674018 C17.987005,9.02815107 17.9093035,9.0237966 17.8316021,9.02391644 L17.2894495,9.02391644 C16.0266907,9.08947332 15.0577593,10.1153725 15.1195609,11.3183671 L15.1195609,13.6163732 C15.0570003,14.8194077 16.0266907,15.8460659 17.2894495,15.911463 L17.6894224,15.911463 C17.050872,17.0576496 16.0521384,17.961184 14.8478655,18.4819237 C14.5487248,18.1740341 14.1049275,18.0546654 13.6916915,18.1710778 L12.1194451,18.6164731 C11.4485758,18.8511754 11.0778059,19.5370258 11.2656877,20.1943123 L11.2821069,20.2634247 C11.4428231,20.8831189 12.1002694,21.2623181 12.7519231,21.108593 L14.3235303,20.6632377 C14.8286898,20.5009635 15.1821216,20.0655556 15.2199137,19.5604361 C17.0426025,18.7572146 18.4442652,17.2831637 19.0987553,15.4760551 C19.6727075,15.0293016 20.0060049,14.3407747 20.0001698,13.6134169 L20.0001698,11.3183671 L19.9930613,11.1404726 C19.998055,11.1048778 20.0001698,11.0679246 20.0001698,11.0316906 C20.0001698,6.50978437 16.4122818,2.85721584 12.0013149,2.85721584 Z"
                id="路径"
                :fill="color"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
  components: {},
  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="less" scoped></style>
